import React, { useState } from "react";
import GoogleLogin from "./socialOauth/google/googleLogin";

import "../authentication/socialOauth/socialOauth.css";

const SocialLogin = ({ isDisabled = false }) => {
  const [authError, setAuthError] = useState(false);
  const [authErrorMsg, setAuthErrorMsg] = useState("");

  return (
    <>
      <div className="text-center social-auth-container">
        <GoogleLogin setAuthError={setAuthError} setAuthErrorMsg={setAuthErrorMsg} isDisabled={isDisabled} />
        {authError &&
          <div className={'alert alert-danger mt-3'}>{authErrorMsg}</div>
        }
      </div>
    </>
  );
};

export default SocialLogin;